import React, { Component } from 'react';
import "./villagercard.css";

import ImgFitness from '../images/hobby/Fitness.png'
import ImgNature from '../images/hobby/Nature.png'
import ImgPlay from '../images/hobby/Play.png'
import ImgMusic from '../images/hobby/Music.png'
import ImgEducation from '../images/hobby/Education.png'
import ImgFashion from '../images/hobby/Fashion.png'
import ImgCrown from '../images/crown.png'


import ImgRosie from '../images/villagers/Rosie.png'

import ChartSpecs from '../data/chart_specs';

const unsortedObj = ChartSpecs.chartspecs.colorWheelObjHobby
const sortObject = o => Object.keys(o).sort((a,b)=>a.localeCompare(b)).reduce((r, k) => (r[k] = o[k], r), {})
const colorWheelObj = sortObject(unsortedObj);
//var colorWheelArray = Object.keys(colorWheelObj);
//var colorRange = Object.values(colorWheelObj);

class VillagerCard extends Component {
  constructor(props){
      super(props);

      this.formatRanking = this.formatRanking.bind(this);
      this.getHobbyIcon = this.getHobbyIcon.bind(this);
   }

   formatRanking(ranking){
     let rankingString = String(ranking);
     if(rankingString.length === 1){
       return  `00${ranking}`;
     }else if (rankingString.length === 2){
       return  `0${ranking}`;
     }else{
       return ranking;
     }
   }

   getHobbyIcon(hobby){
      switch (hobby) {
        case 'Fitness':
          return ImgFitness
          break;
        case 'Nature':
          return ImgNature
          break;
        case 'Play':
          return ImgPlay
          break;
        case 'Music':
          return ImgMusic
          break;
        case 'Fashion':
          return ImgFashion
          break;
        case 'Education':
          return ImgEducation
          break;
      }

  }


  render() {
    const {villager, style} = this.props;

    return (
      <div className='card' style={style}>
        <div className='card-image'>
          <img src={(villager.name === 'Rosie')?ImgRosie:villager.image_url} alt="villager profile" />
        </div>
        <div className='card-content'>
          <div className='card-square'>
            <span className='card-ranking'>{this.formatRanking(villager.Average_Popularity_Ranking)}</span>
            {/*<span className='card-tier' style={{ backgroundImage : `url(${ImgCrown})`}}>{villager.tier}</span> */}
          </div>
          <div className='card-bottom'>
            <div className='card-name'>{villager.name}</div>
            <div className='card-pill'>
              <span className='card-hobby' style={{ backgroundColor: `${colorWheelObj[villager.hobby]}`, backgroundImage : `url(${this.getHobbyIcon(villager.hobby)})`}} aria-label={villager.hobby}></span>
              <span className='card-personality'>{villager.personality}</span>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default VillagerCard;
